import React, { useEffect } from 'react'
import ScrollReveal from 'scrollreveal'


const ScrollAn = () => {
    useEffect(()=>{
        const sr = ScrollReveal({
            origin:'top',
            distance:'40px',
            duration: 2500,
            delay:200,
            reset:true,
        })
        sr.reveal(`.home__data,.projects__scroll,.testimonial__container,.footer__container`)
        sr.reveal(`.home__info div`,{delay:600,origin:'bottom',interval:100})
        sr.reveal(`.skills__content:nth-child(1),.contact__content:nth-child(1)`,{origin:'left'})
        sr.reveal(`.skills__content:nth-child(2),.contact__content:nth-child(2)`,{origin:'right'})
        sr.reveal(`.qualification__content,.services__card`,{interval:100})
    },[])
    return (
        <></>
    )
}

export default ScrollAn